import { blue } from '@material-ui/core/colors';

export default () => ({
  root: {},
  activeItem: {
    color: blue[600],
  },
});
